import { getStrandsPendingLossReason } from "../../components/strand-loss-warnings/getStrandsPendingLossReason";
import type {
  PendingStrandLossWarning,
  PreviousHeatPendingStrandLoss,
  Strand,
} from "../../models/caster.models";

const byHeatStartThenStrand = (
  left: PreviousHeatPendingStrandLoss,
  right: PreviousHeatPendingStrandLoss,
): number =>
  new Date(left.HeatStart).getTime() - new Date(right.HeatStart).getTime() ||
  left.Strand - right.Strand;

const toPreviousHeatWarning = (
  strandLoss: PreviousHeatPendingStrandLoss,
): PendingStrandLossWarning => ({
  strandLossId: strandLoss.StrandLossId,
  strand: strandLoss.Strand,
  heatName: strandLoss.HeatName,
});

const toCurrentHeatWarning = (strand: Strand): PendingStrandLossWarning => ({
  strandLossId: strand.StrandLossId!,
  strand: strand.Strand,
  heatName: null,
});

export const isPreviousHeatWarning = (
  warning: PendingStrandLossWarning,
): boolean => warning.heatName !== null;

export const getPendingStrandLossWarnings = (
  previousHeatStrandLosses: PreviousHeatPendingStrandLoss[],
  currentHeatStrands: Strand[],
): PendingStrandLossWarning[] => [
  ...previousHeatStrandLosses
    .toSorted(byHeatStartThenStrand)
    .map(toPreviousHeatWarning),
  ...getStrandsPendingLossReason(currentHeatStrands)
    .toSorted((left, right) => left.Strand - right.Strand)
    .map(toCurrentHeatWarning),
];
